<template>

<com-item name="hindex.past" :is-cards="true" :size="size" :loading="loading" class="games" title="Past Favourites" v-if="data.past.length">

	<template v-slot:about>

		<p>The games that were on your H-index in the past but are no longer.</p>

	</template>

	<template v-slot:stats>

        <com-card :item="item" v-for="item in data.past" :key="item.g" :id="item.g" :subtitle="'Until Level ' + item.a" :name="$store.getters['data/games/associated'][item.g].name" class="card">

            <core-card-foot-stat :value="item.c" text="play" :plural="true" />

            <core-card-foot-date :value="item.f" text="first play" />

            <core-card-foot-date :value="item.d" text="last play" />

        </com-card>

	</template>

</com-item>

</template>

<script>

import comItem from './../common/Item'
import comCard from './../common/Card'

export default {

	props: ['fetching', 'your', 'you', 'size'],

	components: {
		'com-item': comItem,
        'com-card': comCard
	},

	computed: {

		loading: function() {
		
			return this.fetching
		
		},

		data: function() {

			return this.$store.getters['page/insights/hindex/games']

		},

		active: function() {

			return this.data.past.length && !this.loading

		}

	},

	methods: {

		subtext: function(value) {

			return 'Last played on ' + this.$options.filters.formatDate(value, this.$util.date.format('Do', 'MMMM', 'YYYY'))

		},

		onMoreClick: function() {

			this.$pubsub.$emit('panel.open', {
				type: 'insightsHindexGames'
			})

		}
	
	}

}

</script>

<style scoped>

</style>